<template>
  <div>

    <xolas-table :title="title"
      :url="telcoId ? '/agreements/org/' + telcoId : '/agreements'"
      table-ref="agreements-table"
      :fields="fields"
      :hide-top="hideTop"
      :show-search="showSearch"
      :show-refresh="showRefresh"
      :search-placeholder="searchPlaceholder"
      layer-component="agreement"
      :layer-args="{ id: 'id' }">

      <template v-if="!noAdd" #actions>
        <agreement-action />
      </template>

      <template #controls="props">
        <agreement-controls :row-data="props.rowData" />
      </template>

    </xolas-table>

  </div>
</template>


<script>
import AgreementControls from '@/components/finance/rates/AgreementControls'
import AgreementAction from '@/components/actions/AgreementAction'

export default {
  components: {
    AgreementControls,
    AgreementAction
  },

  props: {
    noAdd: {
      type: Boolean,
      default: false
    },
    siteId: {
      type: Number,
      default: null
    },
    owner: {
      type: Number,
      default: null
    },
    title: {
      type: String,
      default: 'Agreements'
    },
    hideTop: {
      type: Boolean,
      default: false
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    showRefresh: {
      type: Boolean,
      default: true
    },
    searchPlaceholder: {
      type: String,
      default: 'Name, Category, Status...'

    }
  },
  data () {
    return {
      telcoId: this.isTelco() ? Number(this.org().id) : this.owner,
      fields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id'
        },
        {
          name: 'rateGroupId',
          title: 'Rate Group ID',
          sortField: 'rateGroupId',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'status',
          title: 'Status',
          sortField: 'status',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'category',
          title: 'Category',
          sortField: 'category'
        },
        {
          name: 'name',
          title: 'Name',
          sortField: 'name'
        },
        {
          name: 'organisation.shortName',
          title: 'Org. Name'
        },
        {
          name: 'rates.length',
          title: '# Rates'
        },
        {
          name: '__slot:controls',
          title: ''
        }
      ]
    }
  },  // data

  mounted () {
    if (!this.telcoId && this.isTelco()) {
      this.telcoId = Number(this.org().id)
    }
  }
}

</script>
